define('fukit/behavior/fetch.resources.on.event.behavior',['require','exports','module','underscore','backbone','marionette','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Mn       = require('marionette'),
      Promise  = require('bluebird');

  var FetchResourcesOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      // Array of resources that need to be fetched
      // can be defined as a function
      // example:
      // resources: [
      //  myModel,
      //  myCollection
      // ]
      resources: null,
      // defines if a model should be fetched if new
      // can be defined as a function
      // example:
      // fetchModelIfNew: function(resource) { return false }
      fetchModelIfNew: false,
      // the options to be passed to the fetch method
      // can be defined as a function
      fetchOptions: null,
      // called when all resources have successfully
      // fetched
      onAllSuccess: null,
      // called when all resources have successfully
      // synced (fetched and data has been set)
      onAllSync: null,
      // called if any resources have failed fetching
      onAnyError: null,
      // the source of the event
      eventSource: null,
      // listen to this view event
      eventName: 'press',
    },

    initialize: function() {
      var eventSource = this.getOption('eventSource') || this.view;
      this.listenTo(eventSource, this.getOption('eventName'), this.onEvent);
    },

    onEvent: function() {
      this.eventArgs = _.toArray(arguments);
      this.fetchResources();
    },

    fetchResources: function() {
      //prettier-ignore
      var self = this,
          resources = Mn._getValue(this.getOption('resources'), this),
          onAllSuccess = this.getOption('onAllSuccess'),
          onAnyError = this.getOption('onAnyError'),
          onAllSync = this.getOption('onAllSync');

      var afterSync = _.after(resources.length, function() {
        if (onAllSync) {
          onAllSync.call(self);
        }
      });

      var promiseArray = [];
      _.each(
        resources,
        function(resource) {
          self.listenToOnce(resource, 'sync', afterSync);

          var xhr = this.fetchResource(resource);
          if (xhr) {
            promiseArray.push(Promise.resolve(xhr));
          }
        },
        this
      );

      Promise.all(promiseArray)
        .tap(function() {
          if (onAllSuccess) {
            onAllSuccess.call(self);
          }
        })
        .catch(function(e) {
          if (onAnyError) {
            onAnyError.call(self);
          }
          throw e;
        });
    },

    fetchResource: function(resource) {
      if (resource instanceof Backbone.Collection) {
        return resource.fetch(this.getFetchOptions(resource));
      } else if (resource instanceof Backbone.Model) {
        if (!resource.isNew() || this.shouldFetchModelIfNew(resource)) {
          return resource.fetch(this.getFetchOptions(resource));
        }
      }
    },

    getFetchOptions: function(resource) {
      return Mn._getValue(this.getOption('fetchOptions'), this, [resource]);
    },

    shouldFetchModelIfNew: function(resource) {
      return Mn._getValue(this.getOption('fetchModelIfNew'), this, [resource]);
    },
  });

  module.exports = FetchResourcesOnEventBehavior;
});

